import { useCallback } from 'react';

import useWindowSize from './useWindowSize';

/**
 * Scroll Lock Hook
 */

const useScrollLock = () => {
  const { width, offsetWidth } = useWindowSize();

  // Returns whether the lock was applied: the viewport is only measured after mount, so
  // callers that pair the lock with a timed release need to know when it took effect.
  const lockScroll = useCallback(() => {
    if (!width || !offsetWidth) return false;

    const scrollBarCompensation = width - offsetWidth;

    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollBarCompensation}px`;

    return true;
  }, [width, offsetWidth]);

  const unlockScroll = useCallback(() => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }, []);

  /**
   * Return
   */

  return {
    lockScroll,
    unlockScroll,
  };
};

/**
 * Export
 */

export default useScrollLock;
